// extracted by mini-css-extract-plugin
export default {"buttonContainer":"PrimaryButton_buttonContainer__qBLRH","buttonContent":"PrimaryButton_buttonContent__UUhZb"};